import React, {Component} from 'react'
import OrderDesign from './OrderDesign'
import PropTypes from "prop-types"

class ListArtworks extends Component {
    render() {
        const {artworks, onDeleteItem} = this.props

        return (
            <div className="ListArtworks">
                <div className="row">
                    {artworks.map((item, index) => {
                        const {barcode_number, item_number, preview_image} = item
                        const barcode = `#${barcode_number}_${item_number}`
                        return <div key={index} className="itemArtwork col-sm-3">
                            <OrderDesign onDeleteItem={onDeleteItem} preview_image={preview_image} barcode={barcode}/>
                        </div>
                    })}
                </div>
            </div>
        )
    }
}

ListArtworks.propTypes = {
    artworks: PropTypes.array,
    onDeleteItem: PropTypes.func.isRequired
}

export default ListArtworks